import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Collapse,
  Box,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ReqNewQuotation = ({ refer }) => {
  const navigate = useNavigate();
  const [showDetails, setShowDetails] = useState(false);

  return (
    <Card
      elevation={4}
      sx={{
        borderRadius: 3,
        padding: 2,
        border: "1px solid #E0E0E0",
        background: "#FAFAFA",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      }}
    >
      <CardContent>
        <Stack spacing={2}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <InfoOutlinedIcon sx={{ color: "#22AB7D", fontSize: "20px" }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Request New Quotation
            </Typography>
          </Stack>

          <Button
            variant="contained"
            fullWidth
            size="large"
            sx={{
              bgcolor: "#22AB7D",
              fontWeight: 600,
              fontSize: "14px",
              textTransform: "capitalize",
              borderRadius: "10px",
              transition: "all 0.3s ease",
              "&:hover": {
                bgcolor: "#14506A",
              },
            }}
            onClick={() => navigate("/quotation/" + refer)}
          >
            Request for new
          </Button>

          <Typography variant="body2" sx={{ fontSize: "12px", color: "#666" }}>
            By pressing request info, you agree that Songjukti & professionals
            may contact you via phone/text{" "}
            {!showDetails ? (
              <Box
                component="span"
                sx={{
                  color: "#22AB7D",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => setShowDetails(true)}
              >
                read more
              </Box>
            ) : null}
          </Typography>

          <Collapse in={showDetails} timeout="auto" unmountOnExit>
            <Typography
              variant="body2"
              sx={{ fontSize: "12px", color: "#555", lineHeight: 1.6 }}
            >
              about your inquiry, which may involve the use of automated means.
              You are not required to consent as a condition of purchasing any
              property, goods or services. Message/data rates may apply. You
              also agree to our Terms of Use.
              <Box
                component="span"
                sx={{
                  display: "block",
                  marginTop: "6px",
                  color: "#CD4646",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => setShowDetails(false)}
              >
                show less
              </Box>
            </Typography>
          </Collapse>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ReqNewQuotation;
